/**
 * Created by satans17 on 2016/12/21.
 */

import Robot from './robot';

export default class Channel {
  constructor(app) {
    this.app = app;
    this.init();
  }

  init() {
    this.curRole = 'robot';
    this.robot = this.initRobot(this.app);
    // this.ocs = this.initOCS(this.app);
  }

  initRobot() {
    return new Robot(this.app);
  }

  initOCS() {

  }

  /**
   * 切换到机器人
   * @param config
   */
  switchToRobot(config) {
    this.robot.online(config);
    this.curRole = 'robot';
    this.app.view.header.switchRole('robot');
  }

  /**
   * 切换到人工客服
   * @param config
   */
  switchToOCS() {
  }
}



// WEBPACK FOOTER //
// ./src/app/context/channel/index.js